import Tool from './Tool';
import ToolDelete from './ToolDelete';

class ToolDeleteRows extends Tool {
  static toolName = 'Delete rows';

  static action({ controller, selection }) {
    selection.deleteVectorsOnClick(true);
    this.toolActionComplete({ controller });
  }
}

class ToolDeleteColumns extends Tool {
  static toolName = 'Delete columns';

  static action({ controller, selection }) {
    selection.deleteVectorsOnClick(false);
    this.toolActionComplete({ controller });
  }
}

class ToolDeleteTable extends Tool {
  static toolName = 'Delete table';

  static action({ controller, selection }) {
    ToolDelete.action({ controller, selection });
  }
}

export { ToolDeleteColumns, ToolDeleteRows, ToolDeleteTable };
